'use client';

import { LocaleType } from '@/utils/constants';
import { cva } from 'class-variance-authority';
import { useLocale } from 'next-intl';
import { useTranslations } from '@/i18n/use-translations';
import React from 'react';
import WapOnly from '../Responsive/WapOnly';
import WebOnly from '../Responsive/WebOnly';

interface SoldOutBlockProps {
  product: {
    in_stock?: string | number;
    status?: number;
    stock?: number;
  };
}

const soldOutTextClass = cva('text-primary-white', {
  variants: {
    locale: {
      en: 'text-14',
      de: 'text-12',
      es: 'text-12',
      fr: 'text-12',
      it: 'text-12',
      pt: 'text-12',
      fi: 'text-12',
      nl: 'text-12',
    },
  },
});

const soldOutStyles = cva(
  'flex justify-center items-center absolute left-[50%] top-[50%] leading-[11px] aspect-square bg-[#00000099] rounded-[50%] text-center translate-[-50%] flex-col',
  {
    variants: {
      locale: {
        en: 'h-[66px] w-[66px]',
        de: 'h-[90px] w-[90px]',
        es: 'h-[66px] w-[66px]',
        fr: 'h-[90px] w-[90px]',
        it: 'h-[66px] w-[66px]',
        pt: 'h-[66px] w-[66px]',
        fi: 'h-[66px] w-[66px]',
        nl: 'h-[66px] w-[66px]',
      },
    },
  },
);

const SoldOutBlock: React.FC<SoldOutBlockProps> = ({ product }) => {
  const t = useTranslations('product');
  const locale = useLocale() as LocaleType;
  let str: string;

  if (product.status === 2) {
    str = t('soldOut.noRestock');
  } else if (product.stock <= 0) {
    str = t('soldOut.soldOut');
  } else if (product.in_stock === '2') {
    str = t('soldOut.soldOut');
  }

  if (str) {
    return (
      <>
        <WebOnly>
          <div
            className="absolute top-0 left-0 w-full h-full cursor-pointer font-br"
            data-product-sold-out-overlay
          >
            <span
              className="flex justify-center items-center absolute leading-[14px] left-[50%] top-[50%] h-[30%] aspect-square bg-[#00000099] rounded-[50%] text-center translate-[-50%] flex-col"
              data-product-sold-out-badge
            >
              <div
                className={`${soldOutTextClass({ locale })} whitespace-pre-wrap leading-[20px]`}
                dangerouslySetInnerHTML={{ __html: str }}
              />
            </span>
          </div>
        </WebOnly>
        <WapOnly>
          <div
            className="absolute top-0 left-0 w-full h-full cursor-pointer"
            data-product-sold-out-overlay
          >
            <span className={`${soldOutStyles({ locale })}`} data-product-sold-out-badge>
              <div
                className={`text-11 text-primary-white ${soldOutTextClass({ locale })} whitespace-pre-wrap leading-[20px]`}
                dangerouslySetInnerHTML={{ __html: str }}
              />
            </span>
          </div>
        </WapOnly>
      </>
    );
  }

  return null;
};

export default SoldOutBlock;
